import { DataTable } from '@/features/_components/data-table'
import { LoadingDataTable } from '@/features/_components/loading-data-table'
import { queries } from '@/features/_lib/react-query'
import type { TExposedUserDTO } from '@doutorsim/shared/users'
import { useQuery } from '@tanstack/react-query'
import type { ColumnDef } from '@tanstack/react-table'

type TUserWithCompany = TExposedUserDTO & {
  company: { id: string }
}

interface UsersTableProps {
  companyId: string
  search?: string
  columns: ColumnDef<TUserWithCompany>[]
}

//TODO: Replace these constants
const PAGE = 1
const LIMIT = 100

export const UsersTable = ({ columns, companyId, search }: UsersTableProps) => {
  const { data: users = [], isLoading } = useQuery({
    ...queries.users.list({ page: PAGE, limit: LIMIT, companyId }),
    enabled: !!companyId,
  })

  if (isLoading) return <LoadingDataTable columns={columns} />

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes((search ?? '').toLowerCase()),
  )

  const usersWithCompany = filteredUsers.map((user) => ({
    ...user,
    company: { id: companyId },
  }))

  return <DataTable columns={columns} data={usersWithCompany} />
}
